export const pseudoClassValues = {
  active: 'active',
  autofill: 'autofill',
  checked: 'checked',
  default: 'default',
  disabled: 'disabled',
  empty: 'empty',
  enabled: 'enabled',
  even: 'nth-child(even)',
  first: 'first-child',
  'first-of-type': 'first-of-type',
  focus: 'focus',
  'focus-visible': 'focus-visible',
  'focus-within': 'focus-within',
  hover: 'hover',
  indeterminate: 'indeterminate',
  'in-range': 'in-range',
  invalid: 'invalid',
  last: 'last-child',
  'last-of-type': 'last-of-type',
  odd: 'nth-child(odd)',
  only: 'only-child',
  'only-of-type': 'only-of-type',
  'out-of-range': 'out-of-range',
  'placeholder-shown': 'placeholder-shown',
  'read-only': 'read-only',
  required: 'required',
  target: 'target',
  valid: 'valid',
  visited: 'visited',
};
